import { validationTypes } from "../../../../../../../components/finalForms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../../../../data/formFieldType";

const initialState = {
  lClientKey:null,
  lDepartmentKey:null,
  count:null,
};

export const addRenewalConfig = {
  name: "Add Scope",
  initialState: initialState,
  section: [
    {
      sectionId: "NewScopeSection",
      title: "Billing Address Section",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12",
      },
      wrapperTemplate: <div className=""></div>, // Wrapper HTML or Component
      fields: [
        {
          id: "lClientKey",
          label: "Client :",
          Field_Name: "Client Name",
          fieldType: FormFieldTypes.SELECT,
          dataField: "lClientKey",
          fieldSetting: {
            placeholder: "Select Client Name",
            isEnableOnChange: true,
            options: [{ label: '', value: '' }]
          },
          style: {
            containerCss: "col-xxl-12 col-lg-12 mb-2 pr-0",
          },
          validation: [{ type: validationTypes.REQUIRE }],
        },
        {
          id: "lDepartmentKey",
          label: "Department : ",
          Field_Name: "Department",
          fieldType: FormFieldTypes.SELECT,
          dataField: "lDepartmentKey",
          fieldSetting: {
            isEnableOnChange: true,
            placeholder: "Department",
            allowSpace: true,
            option: []
          },
          style: {
            containerCss: "col-md-12 mb-2",
          },
          validation: [{ type: validationTypes.REQUIRE }],
        },
        {
          id: "sInstrumentTypeKey",
          label: "Instrument Type :",
          Field_Name: "Instrument Type",
          fieldType: FormFieldTypes.SELECT,
          dataField: "sInstrumentTypeKey",
          fieldSetting: {
            placeholder: "Instrument Type",
            isEnableOnChange: true,
            option: []
          },
          style: {
            containerCss: "col-xxl-12 col-lg-12 mb-2 pr-0",
          },
          validation: [{ type: validationTypes.REQUIRE }],
        },
        {
          id: "plScopeTypeKey",
          label: "Model :",
          Field_Name: "Model",
          fieldType: FormFieldTypes.SELECT,
          dataField: "plScopeTypeKey",
          fieldSetting: {
            placeholder: "Model",
            isEnableOnChange: true,
          },
          style: {
            containerCss: "col-xxl-12 col-lg-12 mb-2 pr-0",
          },
          validation: [{ type: validationTypes.REQUIRE }],
        },
        {
          id: "count",
          label: "Count :",
          Field_Name: "Count",
          fieldType: FormFieldTypes.INPUT,
          dataField: "count",
          fieldSetting: {
            placeholder: "Count",
            isEnableOnChange: true,
          },
          style: {
            containerCss: "col-xxl-12 col-lg-12 mb-2 pr-0",
          },
        },
      ],
    },
  ],
};
